export default __webpack_public_path__ + "static/media/reactiflux.34ff2641.webp";